import { render, staticRenderFns } from "./edit-user.vue?vue&type=template&id=4d2013a8&scoped=true"
import script from "./edit-user.vue?vue&type=script&lang=ts"
export * from "./edit-user.vue?vue&type=script&lang=ts"
import style0 from "./edit-user.vue?vue&type=style&index=0&id=4d2013a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2013a8",
  null
  
)

export default component.exports